(function () {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Valorisation', Valorisation);

    Valorisation.$inject = ['$resource','DateUtils'];

    function Valorisation ($resource, DateUtils) {
        var resourceUrl =  'api/valorisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                hasBody: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                hasBody: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    console.log(copy);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
